import { Tag } from '@luminovo/api-contracts';
import { isPresent } from '@luminovo/commons';

import { Solution } from '../types';

export function findSolutionTag<T extends Tag['tag']>(
    solution: Pick<Solution, 'solutionTags'> | null | undefined,
    solutionTag: T,
): Extract<Tag, { tag: T }> | null {
    if (!isPresent(solution)) {
        return null;
    }

    const result = solution.solutionTags.find(({ tag }) => tag === solutionTag);

    if (result) {
        return result as Extract<Tag, { tag: T }>;
    }

    return null;
}
